import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
@Injectable()
export class LayoutService {

    HideSideNav$ = new BehaviorSubject(false);
    set HideSideNav(val) {
        this._hideSideNav = val;
        this.HideSideNav$.next(this._hideSideNav);
    }
    _hideSideNav = false;

    ToggleSideNav() {
        this._hideSideNav = !this._hideSideNav;
        this.HideSideNav$.next(this._hideSideNav);
    }
}
